import { render, staticRenderFns } from "./CreateMerchant.vue?vue&type=template&id=a84fa77a&scoped=true"
import script from "./CreateMerchant.vue?vue&type=script&lang=js"
export * from "./CreateMerchant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84fa77a",
  null
  
)

export default component.exports